'use client';

import React from 'react';
import { css, cx } from 'styled-system/css';

const pill = css({
  borderRadius: 'full',
  borderWidth: '1px',
  borderColor: '#14b8a6',
  bg: 'rgb(54, 56, 58)',
});
const pillInner = css({ display: 'flex', alignItems: 'center', justifyContent: 'center', py: '3' });
const pillText = css({ textStyle: { base: 'xs', smDown: 'sm' }, color: 'white' });

export function FlowingDashedLines({ snippet }: { snippet: string }) {
  return (
    <div
      className={css({
        position: 'relative',
        h: '125px',
        w: '460px',
        maxW: 'full',
        overflowX: 'auto',
      })}
    >
      <style>{snippet}</style>
      <div
        className={cx(
          'react-flow__node react-flow__node-primaryNode selectable',
          css({ position: 'absolute', left: '0', top: '10px', w: '92px' }),
        )}
        data-id='users'
        data-testid='rf__node-users'
        tabIndex={0}
        role='button'
        aria-describedby='react-flow__node-desc-1'
        style={{
          zIndex: 0,
          pointerEvents: 'all',
          visibility: 'visible',
        }}
      >
        <div className={pill}>
          <div className={pillInner}>
            <div className={pillText}>Users</div>
          </div>
        </div>
      </div>

      <div
        className={cx(
          'react-flow__node react-flow__node-primaryNode selectable',
          css({ position: 'absolute', left: '180px', top: '3.5', w: '88px' }),
        )}
        data-id='users'
        data-testid='rf__node-users'
        tabIndex={0}
        role='button'
        aria-describedby='react-flow__node-desc-1'
        style={{
          zIndex: 0,
          pointerEvents: 'all',
          visibility: 'visible',
        }}
      >
        <div className={pill}>
          <div className={pillInner}>
            <div className={pillText}>Navi</div>
          </div>
        </div>
      </div>

      <div
        className={cx(
          'react-flow__node react-flow__node-primaryNode selectable',
          css({ position: 'absolute', left: '375px', top: '3.5', w: '88px' }),
        )}
        data-id='users'
        data-testid='rf__node-users'
        tabIndex={0}
        role='button'
        aria-describedby='react-flow__node-desc-1'
        style={{
          zIndex: 0,
          pointerEvents: 'all',
          visibility: 'visible',
        }}
      >
        <div className={pill}>
          <div className={pillInner}>
            <div className={pillText}>Volo</div>
          </div>
        </div>
      </div>
      <svg
        width='462'
        height='123'
        className={cx(
          'react-flow__edges react-flow__container',
          css({ position: 'absolute', left: '0', top: '0' }),
        )}
        style={{ zIndex: 0 }}
      >
        <defs>
          <marker
            className='react-flow__arrowhead'
            id='1__color=#0DC3A4&amp;height=14&amp;type=arrow&amp;width=14'
            markerWidth='14'
            markerHeight='14'
            viewBox='-10 -10 20 20'
            markerUnits='strokeWidth'
            orient='auto-start-reverse'
            refX='0'
            refY='0'
          >
            <polyline
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              points='-5,-4 0,0 -5,4'
              style={{ stroke: 'rgb(13, 195, 164)', strokeWidth: 1 }}
            ></polyline>
          </marker>
          <marker
            className='react-flow__arrowhead'
            id='1__color=#ffffff&amp;height=14&amp;type=arrow&amp;width=14'
            markerWidth='14'
            markerHeight='14'
            viewBox='-10 -10 20 20'
            markerUnits='strokeWidth'
            orient='auto-start-reverse'
            refX='0'
            refY='0'
          >
            <polyline
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              points='-5,-4 0,0 -5,4'
              style={{ stroke: 'rgb(255, 255, 255)', strokeWidth: 1 }}
            ></polyline>
          </marker>
        </defs>
        <g>
          <g
            className='react-flow__edge react-flow__edge-default nopan animated'
            tabIndex={0}
            role='button'
            data-testid='rf__edge-users->volo'
            aria-label='Edge from users to volo'
            aria-describedby='react-flow__edge-desc-1'
          >
            <path
              d='M93.9375,35.20758193359375 C136.7275725708008,35.20758193359375 136.7275725708008,34.70758193359375 179.51764514160158,34.70758193359375'
              fill='none'
              className='react-flow__edge-path'
              markerEnd="url('#1__color=#ffffff&amp;height=14&amp;type=arrow&amp;width=14')"
              markerStart="url('#')"
              style={{ strokeDasharray: 5, strokeWidth: 1, stroke: 'rgb(255, 255, 255)' }}
            ></path>
            <path
              d='M93.9375,35.20758193359375 C136.7275725708008,35.20758193359375 136.7275725708008,34.70758193359375 179.51764514160158,34.70758193359375'
              fill='none'
              strokeOpacity='0'
              strokeWidth='20'
              className='react-flow__edge-interaction'
            ></path>
          </g>
          <g
            className='react-flow__edge react-flow__edge-default nopan animated'
            tabIndex={0}
            role='button'
            data-testid='rf__edge-volo->navi'
            aria-label='Edge from volo to navi'
            aria-describedby='react-flow__edge-desc-1'
          >
            <path
              d='M267.9462340087891,34.20758193359375 C321.6336038208008,34.20758193359375 321.6336038208008,34.70758193359375 375.3209736328125,34.70758193359375'
              fill='none'
              className='react-flow__edge-path'
              markerEnd="url('#1__color=#ffffff&amp;height=14&amp;type=arrow&amp;width=14')"
              markerStart="url('#')"
              style={{ strokeDasharray: 5, strokeWidth: 1, stroke: 'rgb(255, 255, 255)' }}
            ></path>
            <path
              d='M267.9462340087891,34.20758193359375 C321.6336038208008,34.20758193359375 321.6336038208008,34.70758193359375 375.3209736328125,34.70758193359375'
              fill='none'
              strokeOpacity='0'
              strokeWidth='20'
              className='react-flow__edge-interaction'
            ></path>
          </g>
          <g
            className='react-flow__edge react-flow__edge-customEdge nopan animated'
            tabIndex={0}
            role='button'
            data-testid='rf__edge-navi->volo'
            aria-label='Edge from navi to volo'
            aria-describedby='react-flow__edge-desc-1'
          >
            <path
              d='M416.9047138671875 55.12945693359375L 416.9047138671875,76.24550380859375Q 416.9047138671875,97.36155068359375 395.78866699218753,97.36155068359375L 248.88369201660157,97.36155068359375Q 228.26764514160158,97.36155068359375 228.26764514160158,76.74550380859375L228.26764514160158 56.129456933593744L228.26764514160158 55.12945693359375'
              fill='none'
              className='react-flow__edge-path'
              markerEnd="url('#1__color=#0DC3A4&amp;height=14&amp;type=arrow&amp;width=14')"
              style={{ strokeDasharray: 5, strokeWidth: 1, stroke: 'rgb(13, 195, 164)' }}
            ></path>
            <path
              d='M416.9047138671875 55.12945693359375L 416.9047138671875,76.24550380859375Q 416.9047138671875,97.36155068359375 395.78866699218753,97.36155068359375L 248.88369201660157,97.36155068359375Q 228.26764514160158,97.36155068359375 228.26764514160158,76.74550380859375L228.26764514160158 56.129456933593744L228.26764514160158 55.12945693359375'
              fill='none'
              strokeOpacity='0'
              strokeWidth='20'
              className='react-flow__edge-interaction'
            ></path>
          </g>
        </g>
      </svg>
    </div>
  );
}
